import type { ReactNode } from "react";

/** Uma conversa de exemplo do lado da marca: mostra o produto antes de qualquer explicação. */
const AMOSTRA: Array<{ de: "paciente" | "assistente"; texto: string; hora: string }> = [
  { de: "paciente", texto: "Oi! Vocês têm horário para limpeza de pele essa semana?", hora: "21:47" },
  { de: "assistente", texto: "Tenho sim! Quinta às 10h ou às 15h, com a Dra. Camila. Qual fica melhor?", hora: "21:47" },
  { de: "paciente", texto: "Às 10h, por favor", hora: "21:48" },
  { de: "assistente", texto: "Pronto, marquei quinta às 10h. Um dia antes eu te lembro por aqui.", hora: "21:48" },
];

/**
 * A moldura das telas de entrada: marca à esquerda, conteúdo à direita.
 *
 * O lado da marca usa o mesmo fundo pontilhado da conversa do painel e uma
 * conversa de exemplo — quem chega entende o que é o LummiChat sem ler a
 * explicação. No celular ele vira uma faixa curta no topo (`.entrada` no
 * globais.css), só com o nome e a frase.
 */
export function MolduraEntrada({ nota, children }: { nota: ReactNode; children: ReactNode }) {
  return (
    <div className="entrada">
      <aside className="entrada-marca">
        <div className="entrada-marca-bloco flex flex-col gap-9">
          <p className="flex items-center gap-2.5 text-xl font-bold tracking-tight text-[var(--color-tinta)]">
            <span className="flex h-[34px] w-[34px] items-center justify-center rounded-[10px] bg-[var(--color-marca)] text-[15px] text-[var(--color-sobre-marca)]">L</span>
            LummiChat
          </p>
          <div>
            <h2 className="entrada-nome">O WhatsApp da sua clínica atendendo sozinho.</h2>
            <p className="entrada-tagline">O assistente responde, tira dúvidas e marca na agenda. A equipe só entra quando precisa — e vê tudo por aqui.</p>
            {/* A nota de cada tela fica para leitor de tela: a conversa de exemplo já mostra o que ela contava. */}
            <p className="sr-only">{nota}</p>
          </div>
          <div className="entrada-amostra flex flex-col gap-2" aria-hidden>
            {AMOSTRA.map((m, i) => (
              <div
                key={i}
                className={
                  "max-w-[85%] rounded-[14px] px-3 pt-2 pb-1.5 text-[14.5px] leading-[1.45] shadow-[0_1px_1px_rgba(0,0,0,0.05)] dark:shadow-none " +
                  (m.de === "paciente"
                    ? "self-start rounded-tl-[4px] bg-[var(--color-cliente)] text-[var(--color-tinta)]"
                    : "self-end rounded-tr-[4px] bg-[var(--color-agente)] text-[var(--color-agente-tinta)]")
                }
              >
                {m.de === "assistente" && <b className="block text-xs text-[var(--color-marca-forte)]">Assistente</b>}
                {m.texto}
                <small className="block text-right text-[11px] text-[var(--color-fraco)]">{m.hora}</small>
              </div>
            ))}
          </div>
        </div>
      </aside>
      <main className="entrada-form">
        <div className="flex w-full flex-col items-center gap-6">
          {children}
          {/* Páginas estáticas (web/public): link comum, não do roteador. O Google
              exige as duas acessíveis sem login para o "Continuar com o Google". */}
          <nav className="flex gap-4 text-[13px] text-muted-foreground">
            <a href="/privacidade" className="hover:text-foreground hover:underline">
              Privacidade
            </a>
            <a href="/termos" className="hover:text-foreground hover:underline">
              Termos de Uso
            </a>
          </nav>
        </div>
      </main>
    </div>
  );
}
